module.exports = __webpack_public_path__ + "media/images/athletes/1771-e35c4b3eff69a3b82a2c60523e107853.png";